import { useEffect, useRef, useState } from 'react';
import { logAction } from '../../api/logApi';
import { searchVideos } from '../../api/commonApi';
import { call } from '../../funcStore';

const styles = {
  section: {
    background: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  videoList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  videoThumb: {
    maxWidth: '100%',
    borderRadius: '4px',
  },
};

const formatDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

function VTuberVideoList({ vtuberId, parentKey }) {
  const STATE_BEFORE_INIT = "beforeInit"
  const STATE_IDOL = "idol"
  const STATE_SEARCHING = "searching"
  const STATE_NO_VIDEO = "noVideo"
  const STATE_SHOW = "show"
  const STATE_UPDATING = "updating"

  const [state,setState] = useState(STATE_BEFORE_INIT)

  const dataRef = useRef({
    total:0,
    videos:[],
    showVideosNum:10,
  })
  
  useEffect(()=>{
    if(state === STATE_BEFORE_INIT){
      init()
    }
    if(state === STATE_IDOL){
      videoSearch()
    }
    if(state === STATE_UPDATING){
      dataRef.current.showVideosNum += 10
      setState(STATE_SHOW)
    }
  },[state])

  function init(){
    setState(STATE_IDOL)
  }

  async function videoSearch(){
    [dataRef.current.videos,dataRef.current.total] = await searchVideos(vtuberId)
    setState(dataRef.current.videos.length > 0 ? STATE_SHOW : STATE_NO_VIDEO)
  }

  function showMoreVideo(){
    setState(STATE_UPDATING)
  }

  return (
    <section style={styles.section}>
      <h3>配信動画 {dataRef.current.total}件</h3>
      {state === STATE_NO_VIDEO && <div>直近3か月の配信履歴はありません</div>}
      {state === STATE_SHOW && <div style={styles.videoList}>
        {dataRef.current.videos.slice(0,dataRef.current.showVideosNum).map((video) => (
          <a
            key={video.id}
            href={`https://www.youtube.com/watch?v=${video.video_id}`}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              logAction('video_click', {
                vtuberId,
                videoId: video.id,
                source: 'detail',
              })
            }
          >
            <img
              style={styles.videoThumb}
              src={video.thumbnail_url.replace("hqdefault", "mqdefault")}
              alt={video.title}
              loading="lazy"
            />
            <p>
              {video.title} ({formatDuration(video.duration_seconds)})
            </p>
          </a>
        ))}
      </div>}
      {dataRef.current.showVideosNum < dataRef.current.total && <button onClick = {showMoreVideo}>さらに表示</button>}
    </section>
  );
}

export default VTuberVideoList;
